import * as React from "react"
import { Box } from "@mui/material";

import {DateRangeBlock} from "@components";
import { DATE_PERIODS } from "@constants";
import {sellerDeepDiveOffersCurrentPeriod} from "../@signals";
import {rangeDatesShareMbl} from "./Ranges";


export default function SellerDeepDiveOffersEvolutionChartToolbar({dateRange, onChange}) {

    return <Box sx={{ display: 'flex', gap: 2, alignItems: 'center'}}>
        <DateRangeBlock
            currentPeriodLabel={sellerDeepDiveOffersCurrentPeriod.value}
            maxDays={30}
            value={dateRange}
            ranges={rangeDatesShareMbl}
            onChange={onChange}
            onOk = { () => sellerDeepDiveOffersCurrentPeriod.value = DATE_PERIODS.CUSTOM }
        />
    </Box>
}


